import { tryOnBeforeMount, tryOnMounted } from '@vueuse/core';
import type { MaybeRefOrGetter } from 'vue';
import { ref, toValue } from 'vue';

type DropUpParams = {
    dropdownHeight?: MaybeRefOrGetter<number> | number;
    isManualEvaluate?: boolean;
    triggerRef: MaybeRefOrGetter<HTMLElement | undefined>;
};

export function useDropup({ dropdownHeight = -1, isManualEvaluate, triggerRef }: DropUpParams) {
    const isDropup = ref(false);

    function evaluate() {
        const el = toValue(triggerRef);
        if(!el) return;

        const rect = el.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;

        const _dropdownHeight = toValue(dropdownHeight);
        isDropup.value = ((_dropdownHeight > 0) ? spaceBelow < _dropdownHeight : true) && spaceAbove > spaceBelow;
    }

    function init() {
        window.addEventListener('scroll', evaluate, { passive: true });
        window.addEventListener('resize', evaluate, { passive: true });
        evaluate();
    }

    function uninit() {
        window.removeEventListener('scroll', evaluate);
        window.removeEventListener('resize', evaluate);
    }

    if(!isManualEvaluate) {
        tryOnMounted(init);
        tryOnBeforeMount(uninit);
    }

    return { isDropup, evaluate };
}
